import { MorphemeInfoPanelTabContent } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content._components.morpheme-info-panel-tab-content";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { MorphemeInfoPanelContext } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content._context";
import { useMorphemeInfoPanelLearningProgressActionsSection } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content.views.learning-progress.__sections.actions";
import { useMorphemeInfoPanelLearningProgressForgettingCurveSection } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content.views.learning-progress.__sections.forgetting-curve";
import { useMorphemeInfoPanelLearningProgressStatsSection } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content.views.learning-progress.__sections.stats";

export function MorphemeInfoPanelLearningProgressTab() {
  const [infoBackCardSlice, setIsScrolled] = useContextSelectors(
    MorphemeInfoPanelContext,
    (c) => c.infoBackCardSlice.data,
    (c) => c.setIsScrolled,
  );
  const stats = useMorphemeInfoPanelLearningProgressStatsSection({ infoBackCardSlice });
  const forgettingCurve = useMorphemeInfoPanelLearningProgressForgettingCurveSection({
    infoBackCardSlice,
  });
  const actions = useMorphemeInfoPanelLearningProgressActionsSection({
    infoBackCardSlice,
  });

  return (
    <MorphemeInfoPanelTabContent
      groupTitle="Progress"
      onScrolledChange={setIsScrolled}
      sections={[stats, forgettingCurve, actions]}
    />
  );
}
